import ReqClient from './request.class'

/**
 * @description: 人员、素材、应用排行数据
 * @param {*} data
 * dateType {type: 'number', description: '1 今日 2本周 3 上周 4 过去7天 5 过去30天 6 本月 7 上月'}
    gameGroupIds: {type: 'array', items: {…}}
    mediaIds: {type: 'array', items: {…}}
    order: {type: 'string', description: '消耗:real_consume,创角:create_role_num,创角成本create_role_cost,ROI:new_role_roi,付费成本pay_role_user_cost'}
    sort: {type: 'string', description: 'asc ,desc'}
    tableType: {type: 'integer', description: '1 人员排行 2 素材排行 3 应用排行'}
 */
export async function getRankDataByType (data) {
  const Req = new ReqClient({
    url: '/api/homeboard/queryRankData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取媒体分布饼图数据
 * @param {*} data {dateType: 1, gameGroupIds: []}
 */
export async function getMediaChartData (data) {
  const Req = new ReqClient({
    url: '/api/homeboard/mediaRank',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取首页汇总数据
 * @param {*} data
 */
export async function getHomeSummariesData (data) {
  const Req = new ReqClient({
    url: '/api/homeboard/queryPtomDataList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取首页图表数据
 * @param {*} data
 */
export async function getHomeLineData (data) {
  const Req = new ReqClient({
    url: '/api/homeboard/queryChartData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
